import { ProfileData } from '../../types/Profile';

type ProfileLike = Pick<
  ProfileData,
  'TeacherSegments' | 'segmentos' | 'perfil'
> | null;

const CHILDHOOD_SEGMENT_LABELS = new Set([
  'ensino infantil',
  'educação infantil',
  'educacao infantil',
  'ei',
]);

const normalizeSegment = (value: string | null | undefined): string =>
  (value ?? '').normalize('NFD').replace(/\p{M}/gu, '').trim().toLocaleLowerCase();

const isChildhoodSegment = (value: string | null | undefined): boolean =>
  CHILDHOOD_SEGMENT_LABELS.has(normalizeSegment(value));

const hasOnlyChildhoodTeacherSegments = (
  teacherSegments: string[] | null | undefined,
): boolean => {
  if (!teacherSegments?.length) {
    return false;
  }
  return teacherSegments.every(isChildhoodSegment);
};

const hasOnlyChildhoodSchoolSegments = (
  segmentos: string[] | null | undefined,
): boolean => {
  if (!segmentos?.length) {
    return false;
  }
  return segmentos.every(isChildhoodSegment);
};

/**
 * Professor só com segmento infantil (TeacherSegments),
 * ou Coordenador/Escola/Professor em escola só EI (segmentos).
 */
export const isEducationChildhoodProfile = (profile: ProfileLike): boolean => {
  if (hasOnlyChildhoodTeacherSegments(profile?.TeacherSegments)) {
    return true;
  }

  if (!hasOnlyChildhoodSchoolSegments(profile?.segmentos)) {
    return false;
  }

  const profileName = profile?.perfil?.nome?.toLocaleLowerCase() ?? '';
  return (
    profileName === 'coordenador' ||
    profileName === 'escola' ||
    profileName === 'professor'
  );
};
